import { translateAdmin } from '../../../utils/adminTranslations';
import AdminText from '../AdminText';
import React, { useEffect, useRef, useState } from 'react';
import { apiUrl, domainFrontend } from '../../../config'
import { fetchData, formatDate } from '../../../utils/api';
import { boolElemByRole, formatDateTime, formatDateTimeToTM, getNumberOfDays, set_status, showPaymentStatusBooking, showTypeBooking } from '../../../utils/dynamic';
import { useLanguage } from '../../../LanguageContext';
import html2pdf from "html2pdf.js";
import Protected from '../Protected';

const BookingView = ({ booking, onUpdate, onClose }) => {
    const [sealTemp, setSealTemp] = useState(null);
    const [seal, setSeal] = useState(localStorage.getItem("org_seal") || null);

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            localStorage.setItem("org_seal", reader.result);
            setSeal(reader.result);
            setSealTemp(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const putSeal = () => {
        const saved = localStorage.getItem("org_seal");
        if (saved) setSealTemp(saved);
        else alert(translateAdmin("Сначала загрузите печать"));
    };

    const [isDisabled, setIsDisabled] = useState(false);
    const [isSendingEmail, setIsSendingEmail] = useState(false);
    const [emailStatus, setEmailStatus] = useState('');
    const { language } = useLanguage();
    const [rooms, setRooms] = useState([])
    const [bookingStatus, setBookingStatus] = useState([])
    const [bookingStatusMessage, setBookingStatusMessage] = useState('')
    const [message, setMessage] = useState('')
    const [selectedPrice, setSelectedPrice] = useState('')
    const [messageStatusBook, setMessageStatusBook] = useState('')
    const [hasCurrency, setHasCurrency] = useState(false)

    const [secondPrints, setSecondPrints] = useState(2)
    const [printingUser, setPrintingUser] = useState(null)

    const [viewBooking, setViewBooking] = useState({
        ...booking,
        available_from_for_print: booking.available_from,
        available_to_for_print: booking.available_to,
        available_from: formatDate(booking.available_from),
        available_to: formatDate(booking.available_to)
    });
    const [bookingEmail, setBookingEmail] = useState('')
    const [roomId, setRoomId] = useState(0);
    const [noteText, setNoteText] = useState('');

    const [available_from, set_available_from] = useState()
    const [available_to, set_available_to] = useState()
    const [payAtInputStatus, setPayAtInputStatus] = useState()
    const [payStatus, setPayStatus] = useState()

    const [cancelModal, setCancelModal] = useState({
        open: false,
        bookingId: null
    });

    const openCancelModal = (id) => {
        setCancelModal({ open: true, bookingId: id });
    };

    const closeCancelModal = () => {
        setCancelModal({ open: false, bookingId: null });
    };

    const confirmCancel = async (withRefund) => {
        if (withRefund) {
            set_statusComp(booking.id, 'cancelBookRefund')
        } else {
            set_statusComp(booking.id, 'cancelBookNoRefund')
        }
        closeCancelModal();
    };

    const [phoneNumber, setPhoneNumber] = useState('');
    const [cardholdername, setCardholdername] = useState('');
    const [paymentType, setPaymentType] = useState('');
    const [cardholderpassSerNumber, setCardholderpassSerNumber] = useState('');
    const [guests, setGuests] = useState([]);

    const [type, setType] = useState(null)
    const [paymentStatus, setPaymentStatus] = useState(0)
    const [numberBlankCheck, setNumberBlankCheck] = useState('')

    useEffect(() => {
        if (!booking) return;

        const formatted = {
            ...booking,
            available_from_for_print: booking.available_from,
            available_to_for_print: booking.available_to,
            available_from: formatDate(booking.available_from),
            available_to: formatDate(booking.available_to)
        };

        setViewBooking(formatted);

        setBookingEmail(formatted.email_note || '');
        setRoomId(formatted.room_id || 0);
        setNoteText(formatted.note_text || '');

        set_available_from(formatted.available_from);
        set_available_to(formatted.available_to);

        setPhoneNumber(formatted.phone_number || '');
        setCardholdername(formatted.cardholdername || '');
        setPaymentType(formatted.payment_type || '');
        setCardholderpassSerNumber(formatted.payer_passportsn || '');
        setGuests(formatted.guests || []);

        setType(formatted.type);
        setPaymentStatus(formatted.payment_status);

        setPayAtInputStatus(
            formatted.payment_at
                ? formatDateTime(formatted.payment_at)
                : ""
        );

        setPayStatus(
            formatted.payment_at
                ? formatDateTime(formatted.payment_at)
                : ""
        );

        setNumberBlankCheck(
            formatted.type === 1
                ? formatted.blank_number
                : formatted.type === 2 && formatted.payment_type === "card"
                    ? formatted.check_number_card
                    : formatted.type === 2 && formatted.payment_type === "cash"
                        ? formatted.check_number_cash
                        : ""
        );

    }, [booking]);
    

    const handleInputChangeType = (v) => {
        if (v === 2) {
            setPaymentType('card')
        } else {
            setPaymentType('')
        }

        if (paymentStatus === 4 && v !== 3) {
            setPaymentStatus(1)
        }
        setType(v)
        if (v === 3) {
            setPayAtInputStatus(false)
        }
    };

    async function getRooms() {
        try {
            const token = localStorage.getItem('accessToken');
            const rooms = await fetchData(`${apiUrl}/api/sys/get-rooms-by-season`, 'GET', token)
            if (rooms.request.status === 0) {
                setRooms(rooms.request.data)
            }
        } catch (error) {
            console.error("Не удалось получить данные о номерах:", error);
        }
    }
    useEffect(() => {
        getStatus()
        getRooms()
    }, [])


    const fetchCurrentPrinterUser = async () => {
        // Запрос текущ. пользователя
        const token = localStorage.getItem('accessToken');
        const res = await fetchData(`${apiUrl}/api/sys/me`, "GET", token)
        if (res?.request?.status === 0) {
            setPrintingUser(res.request.data)
        }
    }
    useEffect(() => {
        fetchCurrentPrinterUser()
        // Проверяем, есть ли данные rooms и установлен ли room_id
        if (rooms && rooms.length > 0 && viewBooking.room_id) {
            const selectedRoom = rooms.find((room) => room.id === parseInt(viewBooking.room_id));
            setSelectedPrice(selectedRoom ? selectedRoom.price : '');
        }
    }, [rooms, viewBooking.room_id])

    const set_statusComp = async (bookingId, method) => {
        setIsDisabled(true)
        if (method === 'acceptPayment') {
            onUpdate({ ...viewBooking, status: 0 })
        }
        const res = await set_status(bookingId, method, type, numberBlankCheck)
        if (res) {
            setMessageStatusBook(res.message)
            alert(res.message)
        }
        setTimeout(() => setIsDisabled(false), 3000);
    }

    const paymentLink = `${domainFrontend}/f/payment/${viewBooking.book_number}/${viewBooking.payment_code_by_url}`
    const copyToClipboard = () => {
        navigator.clipboard.writeText(paymentLink)
            .then(() => alert(translateAdmin('Ссылка скопирована!')))
            .catch(err => console.error('Ошибка при копировании:', err));
    };

    const getStatus = async () => {
        setIsDisabled(true)
        const token = localStorage.getItem('accessToken');
        try {
            const result = await fetchData(`${apiUrl}/api/sys/get-status-order/${viewBooking.id}`, "GET", token)
            if (result.request.status === 0) {
                setBookingStatus(result.request.data)
            } else {
                setBookingStatusMessage(result.request.message)
            }
        } catch { }
        setTimeout(() => setIsDisabled(false), 3000);
    }
    const save = async (id) => {
        setIsDisabled(true)
        const token = localStorage.getItem('accessToken');
        try {
            const response = await fetchData(`${apiUrl}/api/sys/edit-booking`, "POST", token, {
                body: {
                    id: id,
                    payment_at: payAtInputStatus,
                    type: type,
                    payment_type: paymentType,
                    payment_status: paymentStatus,
                    numberBlankCheck: numberBlankCheck,
                }
            })
            if (response.request.status === 0) {
                const patch = response.request.booking;
                const updated = {
                    ...viewBooking,
                    ...patch
                };
                setViewBooking(updated);
                setMessage(response.request.message)
            } else {
                alert(response.request.message)
            }
        } catch (error) {
            console.error('Ошибка при сохранении данных:', error);
            alert(translateAdmin("Произошла ошибка при сохранении данных."))
        }
        setTimeout(() => setIsDisabled(false), 3000);
    }
    const editGuests = async (id) => {
        setIsDisabled(true)
        const token = localStorage.getItem('accessToken');
        try {
            const response = await fetchData(`${apiUrl}/api/sys/update-rec`, "POST", token, {
                body: {
                    booking_id: id,
                    guests: guests,
                    phone_number: phoneNumber,
                    cardholdername: cardholdername,
                    room_id: parseInt(roomId),
                    payer_passportsn: cardholderpassSerNumber,
                    available_from: available_from,
                    available_to: available_to,
                    note_text: noteText,
                    email_note: bookingEmail,
                }
            })
            if (response.request.status === 0) {
                const patch = response.request.booking;
                const updated = {
                    ...viewBooking,
                    ...patch
                };
                setViewBooking(updated);
                setMessage(response.request.message)
            } else {
                setMessage(response.request.message)
            }
        } catch (error) {
            console.error('Ошибка при обновлении гостей:', error);
        }
        setTimeout(() => setIsDisabled(false), 3000);
    }

    const handleGuestChange = (index, field, value) => {
        const updatedGuests = guests.map((guest, i) =>
            i === index ? { ...guest, [field]: value } : guest
        );
        setGuests(updatedGuests);
    };
    const delGuest = (guest) => {
        const updatedGuests = guests.filter(g => g !== guest);
        setGuests(updatedGuests);
    };

    const handleChangeCheckin = (value) => {
        set_available_from(value);
    }
    const handleChangeCheckout = (value) => {
        set_available_to(value);
    }

    const check = async () => {
        const requestData = {
            room_id: roomId,
            checkin: available_from,
            checkout: available_to
        }
        setIsDisabled(true)
        setMessage('Подождите...')
        try {
            const token = localStorage.getItem('accessToken');
            const response = await fetch(`${apiUrl}/api/sys/reception-check-fr`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(requestData)
            });
            const data = await response.json();
            if (response.ok) {
                setMessage(`${data.message + ': ' + data.count}`)
            } else {
                setMessage(data.message)
                console.error("Ошибка загрузки данных:", response.statusText);
            }
        } catch (error) {
            console.error("Ошибка:", error);
        }
        setTimeout(() => setIsDisabled(false), 3000);
    }
    const handleChangeNoteText = (v) => {
        setNoteText(v)
    }

    const htmlGet = (copiesHtml) => {
        const htmlV = `
            <html>
                <head>
                    <style>
                    .booking-fprint {
                        z-index: 12 !important;
                        position: relative;
                        padding: 0 4px;
                        font-size: 16px;
                        margin: 2px auto;
                    }
                    .upper-text-bank-blank {
                        margin-top: 20px;
                        margin-bottom: 20px;
                        font-size: 22px;
                    }
                    .summ {
                        z-index: -1 !important;
                        position: relative;
                    }
                    .seal-on-print {
                        z-index: -1 !important;
                        position: absolute;
                        right: 0;
                        top: -40px;
                        width: 4cm;
                        height: auto;
                        opacity: 1;
                        border-radius: 12px;
                    }
                    .image-bg {
                        opacity: .4;
                        top: 10px;
                        z-index: -2 !important;
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        -webkit-print-color-adjust: exact; /* Chrome, Safari */
                        color-adjust: exact; /* Firefox */
                        print-color-adjust: exact; /* Стандарт */
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .image-bg img {
                        z-index: -2;
                        width: 99%;
                    }
                    body { font-family: Arial, sans-serif; margin:0; padding:0; }
                    table { width: 100% !important; border-collapse: collapse; border-spacing: 0; page-break-inside: auto; }
                    th, td { border: 1px solid #585858; padding: 2px 2px; text-align: left; word-wrap: break-word; background-color: transparent; }
                    thead { display: table-header-group; }
                    tr { page-break-inside: avoid; }
                    @media print {
                        body * {
                            visibility: hidden;
                        }
                        #booking-fprint, #booking-fprint * {
                            visibility: visible;
                        }
                        .print-copy {
                            page-break-inside: avoid;
                            break-inside: avoid;
                        }
                        /* Линия-разделитель */
                        .copy-separator {
                            border: none;
                            border-top: 1px dashed #000;
                            margin: 10px 0;
                        }
    
                        /* Если перед линией произошёл перенос страницы — скрываем её */
                        .copy-separator {
                            break-before: avoid;
                        }
                        @page { size: A4 portrait; margin: 5mm; }
                        
                    }
                    .table-blank td, .table-blank th {
                        background-color: transparent !important;
                        font-size: 14px;
                    }
                    table { width: 100%; border-collapse: collapse; border-spacing: 0; margin: 0 auto; }
                    .current-pos-print { display: flex; justify-content: space-between; padding: 0 100px; }
                    .under-jcsb {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 5px;
                    }
                    .header-text {
                        text-align: center;
                    }
                    h3, h4, h6 {
                        margin-top: 0;
                        margin-bottom: 0;
                    }
                    .under-line {
                        text-decoration: underline;
                    }
                    .footer-text {
                        text-align: justify;
                        margin-top: 0;
                        margin-bottom: 0;
                    }
                    .footer-text-blank {
                        margin-top: 20px;
                        font-size: 16px;
                    }
                    .footer-text-blank {
                        margin-top: 20px;
                        font-size: 16px;
                    }
                    .list-contacts {
                        font-size: 14px;
                        text-align: right;
                        padding-left: 0;
                        list-style-type: none;
                    }
                    .list-contacts-blank {
                        margin-top: 20px;
                        font-size: 16px;
                    }
                    p {
                        font-size: 14px;
                    }
                    .under-text-blank p {
                        font-size: 18px;
                    }
                    </style>
                </head>
                <body style="padding: 10px 30px;">
                    ${copiesHtml}
                </body>
            </html>
        `
        return htmlV
    }


    const sendBookingToApi = async () => {
        if (isSendingEmail) return;
        if (!bookingEmail.trim()) {
            setEmailStatus(translateAdmin('Укажите email для отправки'));
            return;
        }
        if (!printingUser) {
            setEmailStatus(translateAdmin('Не удалось загрузить данные сотрудника для печати'));
            return;
        }

        const printElement = document.getElementById('booking-fprint');
        if (!printElement) {
            setEmailStatus(translateAdmin('Не удалось сформировать документ для отправки'));
            return;
        }
        const printContents = printElement.outerHTML;

        // 1️⃣ создаём контейнер
        const tempDiv = document.createElement('div');
        tempDiv.style.width = '208mm';
        tempDiv.style.height = '295mm';
        tempDiv.style.padding = '15mm';
        tempDiv.style.boxSizing = 'border-box';
        tempDiv.style.background = '#fff';

        tempDiv.innerHTML = htmlGet(printContents);

        setIsSendingEmail(true);
        setEmailStatus(translateAdmin('Формирование и отправка документа...'));
        document.body.appendChild(tempDiv);

        try {
            const opt = {
                margin: 0,
                filename: 'booking.pdf',
                image: { type: 'jpeg', quality: 1 },
                html2canvas: { scale: 3, useCORS: true },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            };

            const pdfBlob = await html2pdf()
                .set(opt)
                .from(tempDiv)
                .outputPdf('blob');

            
            // const url = URL.createObjectURL(pdfBlob);
            // window.open(url, '_blank');

            const formData = new FormData();
            formData.append('image', pdfBlob, 'booking.pdf');
            formData.append('booking_id', viewBooking.id);
            formData.append('recipient', bookingEmail.trim());
            formData.append('copies', 1);

            const token = localStorage.getItem('accessToken');

            const response = await fetch(`${apiUrl}/api/sys/send-booking-image`, {
                method: 'POST',
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                body: formData
            });

            const data = await response.json();

            if (!response.ok || data.request?.status !== 0) {
                throw new Error(data.request?.message || 'Ошибка');
            }

            setEmailStatus(translateAdmin(data.request.message || 'Чек отправлен на почту'));
        } catch (error) {
            console.error(error);
            setEmailStatus(translateAdmin(error.message || 'Не удалось отправить документ'));
        } finally {
            tempDiv.remove();
            setIsSendingEmail(false);
        }
    };

    const printBooking = async () => {
        if (!viewBooking) return;

        if (printingUser === null) {
            return;
        }
        // Берем только таблицу из модалки
        const printContents = document.getElementById('booking-fprint').outerHTML;

        // Создаем iframe для печати, чтобы не менять страницу
        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        document.body.appendChild(iframe);

        let copiesHtml;
        if (viewBooking.type === 1) {
            copiesHtml = Array(secondPrints)
                .fill(`<div class="print-copy">${printContents}</div>`)
        } else if (viewBooking.type === 2) {
            copiesHtml = Array(secondPrints)
                .fill(`<div class="print-copy">${printContents}</div>`)
                .join('<hr class="copy-separator">');
        }


        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(htmlGet(copiesHtml));
        doc.close();

        await new Promise(resolve => {
            iframe.onload = resolve;
        });

        // маленькая пауза, чтобы CSS точно применился
        await new Promise(r => setTimeout(r, 500));

        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        // Убираем iframe после печати
        setTimeout(() => document.body.removeChild(iframe), 1000);
    }

    function getRoomType(room_id) {
        // Находим комнату по room_id
        const room = rooms.find(r => r.id === room_id);

        // Проверяем существование комнаты и переводов
        if (!room || !room.translations || !room.translations.room_type) {
            return "null"; // или пустую строку, или значение по умолчанию
        }

        // Возвращаем перевод для указанного языка или fallback
        return room.translations.room_type['tm']
            || '';
    }

    useEffect(() => {
        const hasCurrencyGuest = guests.some(g => g.currency === 1);
        setHasCurrency(hasCurrencyGuest)
        if (hasCurrencyGuest) {
            if (paymentStatus !== 4) {
                setPaymentStatus(2);
            }
        }
    }, [guests, setHasCurrency, setPaymentStatus])

    return (
        <React.Fragment>

            <div id='booking-fprint' className='booking-fprint'>
                <div className="header-text">
                    <h3>“AWAZA” MILLI SYÝAHATÇYLYK ZOLAGYNDA ÝERLEŞÝÄN<br />
                        “BERKARAR” MYHMANHANASYNYŇ ÝAŞAÝYŞ OTAGLARYNYŇ<br />
                        TÖLEGI BARADAKY KEPILNAMASY</h3>
                    <h4>“Türkmenengaz” Döwlet konserni</h4>
                    <h4>"Berkarar" döwlet kärhanasy</h4>
                </div>

                {viewBooking.type === 1 &&
                    <div className='upper-text-bank-blank'>
                        <h6><AdminText>Salgyt налоговый код 301111000004</AdminText></h6>
                        <h6>Türkmenistanyň “Türkmenbaşy” Paýdarlar</h6>
                        <h6>Täjirçilik Bankynyň Türkmenbaşy şahamçasy</h6>
                        <h6><AdminText>MFO(BAB) МФО 390601312</AdminText></h6>
                        <h6><AdminText>HAS.hasaby Расчетный счет 23201934131202100045000</AdminText></h6>
                        <h6><AdminText>Anyk.belgi Кор.счет 21101934110100300007000</AdminText></h6>
                    </div>
                }
                <h6 style={{ marginBottom: '10px', fontSize: '16px' }}>
                    {viewBooking?.payment_status === 1 ? "Öňünden bron üçin töleg çek №" :
                        viewBooking?.payment_status === 2 ? "Öňünden ýaşaýyş üçin töleg çek №" :
                            viewBooking?.payment_status === 3 ? "Öňünden ýaşaýyş we bron üçin töleg çek №" : ''
                    } {viewBooking?.type === 1 ? viewBooking.blank_number || '-' : viewBooking?.type === 2 && viewBooking.payment_type === 'card' ? viewBooking.check_number_card || '-' : viewBooking?.type === 2 && viewBooking.payment_type === 'cash' ? viewBooking.check_number_cash || '-' : '-'}
                </h6>

                <table className={`${viewBooking.type === 1 && 'table-blank'}`}>
                    <thead>
                        <tr>
                            <th>Otag</th>
                            <th>Giriş</th>
                            <th>Çykyş</th>
                            <th>Bir gije-gundiz bahasy</th>
                            <th>Adam sany</th>
                            <th>Kepilnama berlen senesi (24 sagat wagty bar)</th>
                            <th>Tel. nomer</th>
                            {viewBooking.type === 4 &&
                                <th>Kompaniýa</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{getRoomType(viewBooking.room_id)}</td>
                            <td>{viewBooking.available_from_for_print}</td>
                            <td>{viewBooking.available_to_for_print}</td>
                            <td>{viewBooking.price_with_extra_guests || ''}</td>
                            <td>{guests?.length || ''}</td>
                            <td>{viewBooking.report_confirmed_at && formatDateTimeToTM(viewBooking.report_confirmed_at) || ''}</td>
                            <td>{viewBooking.phone_number || ''}</td>
                            {viewBooking.type === 4 &&
                                <td>{viewBooking.note_text}</td>
                            }
                        </tr>
                    </tbody>
                </table>
                <br />
                <table className={`${viewBooking.type === 1 && 'table-blank'}`}>
                    <thead>
                        <tr>
                            <th>№</th>
                            <th>Familiyasy, ady</th>
                            <th>Pasport seriýa</th>
                        </tr>
                    </thead>
                    <tbody>
                        {guests && guests.map((guest, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{guest.full_name || ''}</td>
                                <td>{guest.passport_serial_number || ''}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className={`under-jcsb summ ${viewBooking.type === 1 && 'under-text-blank'}`}>
                    <div></div>
                    {viewBooking.amount_booking ?
                        <p><strong>Bron etmek hyzmaty:</strong> {viewBooking.amount} {viewBooking.currency === 1 ? "$" : "TMT"}</p>
                        :
                        <p><strong>Jemi:</strong> {viewBooking.amount} {viewBooking.currency === 1 ? "$" : "TMT"}</p>
                    }
                    {sealTemp && (
                        <img
                            src={sealTemp}
                            alt="Seal"
                            className='seal-on-print'
                        />
                    )}
                </div>
                <div className='image-bg'>
                    <img
                        src="/static/backgr.png"
                        alt="bg"
                    />
                </div>
                <div className={`${viewBooking.type === 1 && 'under-text-blank'}`}>
                    <p><strong>Syýahatçylyk bölüminiň başlygy:</strong> Şyhyýewa O.</p>

                    <p><strong>Tölegi kabul eden:</strong> {printingUser && `${printingUser.last_name} ${printingUser.first_name}`}</p>
                </div>
                <p className={`footer-text ${viewBooking.type === 1 && 'footer-text-blank'}`}>
                    Bellik: <span style={{ color: 'blue' }}>Hormatly myhmanlar, hasaba alyş tertibine laýyklykda, her bir myhmanyň şahsyýetini tassyklaýan resminamasyny öz ýanyňyzda getirmegiňizi haýyş edýäris. Myhmanhananyň bentlenilen otaglaryna diňe bentleninde görkezilen raýatlar ýerleşdirilýär!<br />
                    {Number(paymentStatus) !== 1 && 
                        <>
                            Eger-de müşderi gelip bilmedik ýagdaýynda 72 sagat önünden myhmanhanamyza ýazmaça ýa-da onlaýn elektron poçtamyza habar etmeli.<br />
                            Müşderi otaga ýerleşmese we bu barada myhmanhana öňünden duýdurmasa tölegiňiz yzyna gaýtarylmaýar.
                        </>
                    }
                    {viewBooking.amount_booking !== null &&
                        <>
                            “Gelip bilmedik ýagdaýyňyzda, bron üçin tölenen töleg yzyna gaýtarylmaýar.”
                        </>
                    }
                        <div style={{ color: 'red' }}>
                            <>
                                Myhmanlarymyzyň rahat dynç almagy biziň üçin örän möhümdir. Şonuň üçin otaglara kolonkaly ses enjamlaryny geçirmäge rugsat berilmeýär.(gadagan) Bu düzgün ähli myhmanlaryň asuda dynç almagy üçin girizilendir.
                            </>
                        </div>
                    </span>
                </p>
                <ul className={`list-contacts ${viewBooking.type === 1 && 'list-contacts-blank'}`}>
                    <li>Türkmenistan, “Awaza” milli syýahatçylyk zolagy</li>
                    <li>berkarar.travel.avaza@sanly.tm</li>
                    <li>berkararotel.com.tm</li>
                    <li>+993 243 57654 / +993 243 57635</li>
                    <li>+993 63 935800 / +993 63 895855</li>
                </ul>
            </div>


            <div className='system-background-hide'>
                <section className="system-container system-container-form">
                    <div className='system-container__inner'>
                        <header className="system-header"><AdminText>Просмотр</AdminText></header>
                        <div className="system-form">
                            {boolElemByRole(['admin', 'booker-admin']) &&
                                <div className="system-column">
                                    <div className="system-input-box">
                                        <label><AdminText>Статус от банка</AdminText></label>
                                        <p>
                                            {bookingStatus.ErrorMessage}
                                        </p>
                                        <p>
                                            <AdminText>Статус заказа:</AdminText> {bookingStatus.OrderStatus}
                                        </p>
                                    </div>
                                </div>
                            }
                            <div className="system-column">
                                {boolElemByRole(['admin', 'booker', 'booker-admin']) &&
                                    <div className="system-input-box">
                                        <label><AdminText>Тип брони</AdminText></label>
                                        <select disabled={viewBooking.type === 0 || viewBooking.locked_type || viewBooking.report_confirmed_at} onChange={(e) => handleInputChangeType(parseInt(e.target.value))} value={type} name='type'>
                                            <option value={1}><AdminText>Бланк</AdminText></option>
                                            <option value={2}><AdminText>Чек</AdminText></option>
                                            <option value={3}><AdminText>Заметка</AdminText></option>
                                            <option value={4}><AdminText>Перечисление</AdminText></option>
                                            {viewBooking.type === 0 &&
                                                <option value={0}><AdminText>Онлайн</AdminText></option>
                                            }
                                        </select>
                                    </div>
                                }
                                {viewBooking.payment_status &&
                                    <div className="system-input-box">
                                        <label><AdminText>Оплата:</AdminText></label>
                                        <select
                                            disabled={viewBooking.type === 0 || viewBooking.report_confirmed_at}
                                            onChange={(e) => setPaymentStatus(Number(e.target.value))}
                                            value={Number(paymentStatus)}
                                            name="paymentStatus"
                                        >
                                            {!hasCurrency && (
                                                <option value={1}><AdminText>Бронь</AdminText></option>
                                            )}
                                            <option value={2}><AdminText>Номер</AdminText></option>
                                            {!hasCurrency && (
                                                <option value={3}><AdminText>Бронь и номер</AdminText></option>
                                            )}
                                            {type === 3 && (
                                                <option value={4}><AdminText>Без оплаты</AdminText></option>
                                            )}
                                        </select>
                                    </div>
                                }
                                {type === 2 &&
                                    <div className="system-input-box">
                                        <label><AdminText>Тип оплаты:</AdminText></label>
                                        <select
                                            disabled={viewBooking.locked_type || viewBooking.report_confirmed_at}
                                            onChange={(e) => setPaymentType(String(e.target.value))}
                                            value={String(paymentType)}
                                            name="paymentType"
                                        >
                                            <option value="card"><AdminText>Карта</AdminText></option>
                                            <option value="cash"><AdminText>Наличные</AdminText></option>
                                        </select>
                                    </div>
                                }

                                {viewBooking.report_confirmed_at &&
                                    <div className="system-input-box">
                                        <label><AdminText>Отдано на оплату -</AdminText></label>
                                        <p>
                                            {formatDateTime(viewBooking.report_confirmed_at)}
                                        </p>
                                    </div>
                                }
                                <div className="system-input-box">
                                    <label><AdminText>Время оплаты -</AdminText> <br />{payStatus}</label>
                                    {viewBooking.type !== 0 &&
                                        <input type='datetime-local'
                                            disabled={(viewBooking.report_confirmed_at && viewBooking.payment_at) && !(boolElemByRole(['admin', 'booker-admin']))}
                                            onChange={(e) => setPayAtInputStatus(e.target.value)}
                                            name='payment_status'
                                            value={payAtInputStatus} />
                                    }
                                </div>
                                <div className="system-input-box">
                                    <label><AdminText>Бронь добавлена -</AdminText></label>
                                    <p>
                                        {formatDateTime(viewBooking.created_at)}
                                    </p>
                                </div>
                                <div className="system-input-box">
                                    <label><AdminText>Общая сумма</AdminText></label>
                                    <p>
                                        {viewBooking.amount} {viewBooking.currency === 1 ? "$" : "TMT"}
                                    </p>
                                </div>
                            </div>

                            {/* {boolElemByRole(['admin', 'booker']) &&
                                ((viewBooking.type === 2 && viewBooking.status == 0) &&
                                    <div className="system-input-box">
                                        <label><AdminText>Ссылка для оплаты</AdminText></label>
                                        <input readOnly placeholder={translateAdmin("Ссылка для оплаты")} className='cursor-pointer hover-fun' value={paymentLink} onClick={copyToClipboard} type="text" name='book_number' />
                                    </div>
                                )
                            } */}

                            <div className="system-column">
                                {type !== 0 && type !== 4 && type !== 3 &&
                                    <div className="system-input-box">
                                        <label>{translateAdmin('Номер')} {type === 1 ? translateAdmin('бланка') : type === 2 ? translateAdmin('чека') : ''}</label>
                                        <input disabled={true} placeholder={`${translateAdmin('Появится после сохранения')} ${type === 1 ? translateAdmin('бланка') : type === 2 ? translateAdmin('чека') : ''}`} value={numberBlankCheck} onChange={(e) => setNumberBlankCheck(e.target.value)} type="number" name="numberBlankCheck" />
                                    </div>
                                }
                                {type !== 3 &&
                                    <div className="system-input-box">
                                        <label><AdminText>Номер брони</AdminText></label>
                                        <input disabled placeholder={translateAdmin("Появится при оплате")} value={viewBooking.book_number} type="text" name='book_number' />
                                    </div>
                                }

                                <div className="system-input-box">
                                    <label><AdminText>Телефон</AdminText></label>
                                    <input placeholder="" onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumber || ''} type="telephone" name="phone_number" />
                                </div>
                            </div>

                            {!viewBooking.report_confirmed_at &&
                                <button className='booking-form__guests__add' type='button' onClick={() => setGuests([...guests, { full_name: '', passport_serial_number: '', currency: 0 }])}><AdminText>+ Добавить гостя</AdminText></button>
                            }
                            <div className='booking-form__guests'>
                                {guests && guests.map((guest, index) => (
                                    <div key={index} className='booking-form__guests__guest'>

                                        {!viewBooking.report_confirmed_at &&
                                            <div className='booking-form__guests__rm' onClick={() => delGuest(guest)}>X</div>
                                        }
                                        <div className="system-input-box">
                                            <label>#{1 + index} <AdminText>Полное имя гостя</AdminText></label>
                                            <input placeholder="" disabled={viewBooking.report_confirmed_at} onChange={(e) => handleGuestChange(index, 'full_name', e.target.value)} value={guest.full_name || ""} type="text" />
                                        </div>
                                        <div className="system-input-box">
                                            <label><AdminText>Серийный номер паспорта</AdminText></label>
                                            <input placeholder="" disabled={viewBooking.report_confirmed_at} onChange={(e) => handleGuestChange(index, 'passport_serial_number', e.target.value)} value={guest.passport_serial_number || ""} type="text" />
                                        </div>
                                        <div className="system-input-box">
                                            <label><AdminText>Гражданин</AdminText></label>
                                            <select disabled={viewBooking.report_confirmed_at} onChange={(e) => handleGuestChange(index, 'currency', parseInt(e.target.value))} value={guest.currency || 0}>
                                                <option value={0}><AdminText>Туркменистана</AdminText></option>
                                                <option value={1}><AdminText>Иностранный</AdminText></option>
                                            </select>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="system-column">
                                {viewBooking.cardholdername ? (
                                    <div className="system-input-box">
                                        <label><AdminText>Полное имя плательщика</AdminText></label>
                                        <input disabled={viewBooking.report_confirmed_at} placeholder="" value={cardholdername || ""} onChange={(e) => setCardholdername(e.target.value)} type="text" name='cardholdername' />
                                    </div>
                                ) : (
                                    <div className="system-input-box">
                                        <label><AdminText>Полное имя плательщика</AdminText></label>
                                        <input disabled={viewBooking.report_confirmed_at} placeholder="" value={cardholdername || ""} onChange={(e) => setCardholdername(e.target.value)} type="text" name='cardholdername_old' />
                                    </div>
                                )}
                                <div className="system-input-box">
                                    <label><AdminText>Серийный номер паспорта</AdminText></label>
                                    <input disabled={viewBooking.report_confirmed_at} placeholder="" value={cardholderpassSerNumber || ""} onChange={(e) => setCardholderpassSerNumber(e.target.value)} type="text" name='payer_passportsn' />
                                </div>
                            </div>
                            {/* {boolElemByRole(['admin', 'booker']) ? (
                                viewBooking.card_number ? (
                                    <div className="system-input-box">
                                        <label><AdminText>4 последние цифры банковской карты</AdminText></label>
                                        <input disabled placeholder="" value={viewBooking.card_number || ''} type="text" name='card_number' />
                                    </div>
                                ) : (
                                    <div className="system-input-box">
                                        <label><AdminText>4 последние цифры банковской карты</AdminText></label>
                                        <input disabled placeholder="" value={viewBooking.card_number_old || ''} type="text" name='card_number_old' />
                                    </div>
                                )):(null)
                            } */}

                            {/* <div className="system-input-box">
                                <label><AdminText>Почта</AdminText></label>
                                <input disabled placeholder="" value={viewBooking.email} type="telephone" name="email" />
                            </div> */}

                            <div className="system-column">
                                <div className="system-input-box">
                                    <label><AdminText>Начало брони</AdminText></label>
                                    <input disabled={viewBooking.report_confirmed_at} value={available_from} onChange={(e) => handleChangeCheckin(e.target.value)} placeholder={translateAdmin("Заезд")} type="date" name='available_from' />
                                </div>
                                <div className="system-input-box">
                                    <label><AdminText>Окончание брони</AdminText></label>
                                    <input disabled={viewBooking.report_confirmed_at} value={available_to} onChange={(e) => handleChangeCheckout(e.target.value)} placeholder={translateAdmin("Выезд")} type="date" name='available_to' />
                                </div>
                            </div>
                            <div className="system-input-box system-address">
                                <label><AdminText>Тип номера</AdminText></label>
                                <div className="system-column">
                                    <div className="system-select-box">
                                        <select required disabled={viewBooking.type === 0} value={roomId} onChange={(e) => setRoomId(e.target.value)} name='room_id'>
                                            {rooms && rooms.length > 0 ? (
                                                rooms.map((room) => (
                                                    <option key={room.id} value={room.id}>{room.translations.room_type[language]}</option>
                                                ))
                                            ) : (
                                                <option value={0}><AdminText>Нет номеров</AdminText></option>
                                            )}
                                        </select>
                                    </div>
                                    <input disabled placeholder={selectedPrice || translateAdmin("Цена не доступна")} type="text" />
                                </div>
                            </div>
                            <div className="system-column">
                                <div className="system-input-box">
                                    <label>Email</label>
                                    <input value={bookingEmail} onChange={(e) => setBookingEmail(e.target.value)} placeholder={translateAdmin("Текст")} type="text" name='note_text' />
                                </div>
                                <div className="system-input-box">
                                    <label><AdminText>Заметка</AdminText></label>
                                    <input value={noteText} onChange={(e) => handleChangeNoteText(e.target.value)} placeholder={translateAdmin("Текст")} type="text" name='note_text' />
                                </div>
                                {emailStatus && <p role="status" aria-live="polite">{emailStatus}</p>}
                            </div>
                            {boolElemByRole(['admin', 'booker-admin']) && (
                                viewBooking.created_by_user_name &&
                                <p><AdminText>Создал:</AdminText> {viewBooking.created_by_user_name}</p>
                            )}
                            {sealTemp && (
                                <p><AdminText>Печать стоит</AdminText></p>
                            )}
                            {message}
                            <div className='flex-btns gap-10'>
                                {seal === null &&
                                    <input className="file-input" type="file" accept="image/*" onChange={handleFile} />
                                }
                                <button
                                    className="system-booking-table-btn system-booking-table-btn-edit"
                                    onClick={() => putSeal()}
                                >
                                    <AdminText>Поставить печать</AdminText>
                                </button>
                            </div>
                            <div className='flex-btns booking-cancel-modal'>
                                {boolElemByRole(['admin', 'booker', 'booker-admin']) && (
                                    <>
                                        {cancelModal.open && (
                                            <div className="modal-overlay">
                                                <div className="modal-box">
                                                    <h3><AdminText>Отменить бронь?</AdminText></h3>
                                                    {viewBooking.status === 0 && (
                                                        <p><AdminText>Выберите тип отмены</AdminText></p>
                                                    )}

                                                    <div className="modal-buttons">
                                                        {viewBooking.status === 1 && (
                                                            <button
                                                                className="btn btn-refund"
                                                                onClick={() => confirmCancel(false)}
                                                            >
                                                                <AdminText>Отменить</AdminText>
                                                            </button>
                                                        )}
                                                        {viewBooking.status === 0 && (
                                                            <>
                                                                <button
                                                                    className="btn btn-refund"
                                                                    onClick={() => confirmCancel(true)}
                                                                >
                                                                    <AdminText>С возвратом</AdminText>
                                                                </button>

                                                                <button
                                                                    className="btn btn-no-refund"
                                                                    onClick={() => confirmCancel(false)}
                                                                >
                                                                    <AdminText>Без возврата</AdminText>
                                                                </button>
                                                            </>
                                                        )}

                                                        <button className="btn btn-cancel" onClick={closeCancelModal}>
                                                            <AdminText>Не отменять</AdminText>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {(viewBooking.status === 0 || viewBooking.status === 1 && viewBooking.booking_status === 0) && (
                                            <button
                                                className="system-booking-table-btn system-booking-table-btn-cancel"
                                                onClick={() => openCancelModal(booking.id)}
                                            >
                                                <AdminText>Отменить бронь</AdminText>
                                            </button>
                                        )}
                                        {/* {((viewBooking.type === 1 || viewBooking.type === 2 || viewBooking.type === 4 || (viewBooking.type == 3 && (viewBooking.payment_status == 1 || viewBooking.payment_status == 2 || viewBooking.payment_status == 3))) && viewBooking.status === 1) && (
                                        <button className="system-booking-table-btn system-booking-table-btn-view" disabled={type == 3 ? 'disabled' : isDisabled} onClick={() => set_statusComp(booking.id, 'acceptPayment')}><AdminText>Подтвердить оплату</AdminText></button>
                                        )} */}
                                        {(viewBooking.type === 1 || viewBooking.type === 2) &&
                                            <>
                                                {((viewBooking.report_confirmed_at) ?
                                                    <Protected
                                                        element={<button className="system-booking-table-btn system-booking-table-btn-view" disabled={isDisabled} onClick={() => set_statusComp(booking.id, 'confirmActiveAbort')}>{translateAdmin('Отменить оплату')} {type === 1 ? translateAdmin('бланка') : type === 2 ? translateAdmin('чека') : ''}</button>}
                                                        requiredRoles={['admin', 'booker-admin']}
                                                        url='hideelem'
                                                    />
                                                    : <button className="system-booking-table-btn system-booking-table-btn-view" disabled={isDisabled} onClick={() => set_statusComp(booking.id, 'confirmActive')}>{translateAdmin('Подтвердить оплату')} {type === 1 ? translateAdmin('бланка') : type === 2 ? translateAdmin('чека') : ''}</button>
                                                )}
                                                <button type='button' className="system-booking-table-btn system-booking-table-btn-view" disabled={isSendingEmail} onClick={sendBookingToApi}>
                                                    {isSendingEmail ? <AdminText>Отправка...</AdminText> : <AdminText>Отправить по почте</AdminText>}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="system-booking-table-btn system-booking-table-btn-view"
                                                    style={{ marginRight: "1px" }}
                                                    onClick={() => setSecondPrints(prev => (prev > 1 ? prev - 1 : 1))}
                                                >
                                                    -
                                                </button>
                                                <button type='button' className="system-booking-table-btn system-booking-table-btn-view" disabled={isDisabled} style={{ marginRight: 0 }} onClick={() => printBooking()}>{secondPrints} Печать</button>
                                                <button
                                                    type="button"
                                                    className="system-booking-table-btn system-booking-table-btn-view"
                                                    style={{ marginLeft: "1px" }}
                                                    onClick={() => setSecondPrints(prev => prev + 1)}
                                                >
                                                    +
                                                </button>
                                            </>
                                        }
                                        <button type='button' className="system-booking-table-btn system-booking-table-btn-edit" disabled={isDisabled} onClick={() => check()}><AdminText>Проверить</AdminText></button>
                                        <button className="system-booking-table-btn system-booking-table-btn-view" disabled={isDisabled} onClick={() => editGuests(booking.id)}><AdminText>Изменить</AdminText></button>
                                        {viewBooking.type !== 0 &&
                                            <button className="system-booking-table-btn system-booking-table-btn-view" disabled={isDisabled} onClick={() => save(booking.id)}><AdminText>Сохранить статус</AdminText></button>
                                        }
                                    </>
                                )}
                                <button type='button' className="system-booking-table-btn system-booking-table-btn-cancel" onClick={onClose}><AdminText>Закрыть</AdminText></button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </React.Fragment>
    );
}

export default BookingView;